import React from 'react'
import PropTypes from 'prop-types'
import { Box, IconButton, TextField, Tooltip } from '@material-ui/core'
import { Send as SendIcon } from 'react-feather'
import useStyles from './styles'

const CommentForm = ({ value, onChange, onSubmit, disabled, placeholder }) => {
  const classes = useStyles()

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      onSubmit()
    }
  }

  return (
    <Box className={classes.addRow}>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        variant="outlined"
        size="small"
        fullWidth
        multiline
        minRows={2}
        disabled={disabled}
      />
      <Tooltip title="Enviar">
        <span>
          <IconButton
            size="small"
            color="primary"
            className={classes.sendButton}
            onClick={onSubmit}
            disabled={!value.trim() || disabled}
          >
            <SendIcon size={18} />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}

CommentForm.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
}

CommentForm.defaultProps = {
  disabled: false,
  placeholder: 'Adicionar comentário... (Enter para enviar)',
}

export default CommentForm
